var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('v-skeleton-loader',{attrs:{"loading":_vm.visible,"type":"chip"}}):_vm._e(),(_vm.visible)?_c('v-skeleton-loader',{attrs:{"loading":_vm.visible,"type":"card-heading"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }